var moduleMap = {
	"./router": () => {
		return __webpack_require__.e(8600).then(() => (() => ((__webpack_require__(28600)))));
	},
	"./SubrouteRenderer": () => {
		return __webpack_require__.e(5394).then(() => (() => ((__webpack_require__(85394)))));
	},
	"./SubrouteNavigation": () => {
		return __webpack_require__.e(5135).then(() => (() => ((__webpack_require__(75135)))));
	},
	"./eventBus": () => {
		return __webpack_require__.e(7197).then(() => (() => ((__webpack_require__(47197)))));
	},
	"./i18n": () => {
		return Promise.all([__webpack_require__.e(1485), __webpack_require__.e(2117)]).then(() => (() => ((__webpack_require__(62117)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});